import script from "./GmxFileUploadDone.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxFileUploadDone.vue?vue&type=script&setup=true&lang=js"

import "./GmxFileUploadDone.vue?vue&type=style&index=0&id=c74a9786&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c74a9786"]])

export default __exports__